import { Box, PageTemplate } from '@npco/zeller-design-system'

import { useLoggedInUser } from 'hooks/useLoggedInUser'
import { CustomerRole } from 'types/gql-global-types'
import { TransactionUpdates } from 'services/transactionUpdates/TransactionUpdates'

import { isNotNull } from '../../../utils/common'
import { GlobalErrorPage } from '../Fallbacks'
import { useDashboardErrors } from '../hooks/useDashboardErrors'
import { DashboardHeader } from './DashboardHeader/DashboardHeader'
import { DashboardTabs } from './DashboardTabs'
import { useGetSavingsAccounts } from './OverviewBanner/hooks/useGetSavingsAccounts/useGetSavingsAccounts'
import { OverviewBanner } from './OverviewBanner/OverviewBanner'
import { useGetInterestRate } from './OverviewBanner/SavingsAccountOverviewBanner/hooks/useGetInterestRate/useGetInterestRate'

interface DashboardLayoutProps {
  children: React.ReactNode
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { userRole } = useLoggedInUser()
  const { shouldDisplayError, retry } = useDashboardErrors()
  const { savingsAccounts, isLoadingSavingsAccounts, savingsAccountsError } =
    useGetSavingsAccounts()
  const { interestRate, isLoadingInterestRate, interestRateError } =
    useGetInterestRate()

  if (shouldDisplayError) {
    return <GlobalErrorPage retry={retry} />
  }

  return (
    <TransactionUpdates>
      <Box pt={{ _: '64px', MD: '0px' }} />
      {userRole === CustomerRole.ADMIN && (
        <OverviewBanner
          savingsAccounts={savingsAccounts.filter(isNotNull)}
          interestRate={interestRate}
          isLoading={isLoadingSavingsAccounts || isLoadingInterestRate}
          error={savingsAccountsError ?? interestRateError}
        />
      )}
      <PageTemplate
        HeaderPrimaryRow={<DashboardHeader />}
        HeaderSecondaryRow={
          userRole === CustomerRole.ADMIN ? <DashboardTabs /> : null
        }
      >
        {children}
      </PageTemplate>
    </TransactionUpdates>
  )
}
